export default __webpack_public_path__ + "static/media/cards3.b225c9dc.png";